<div class="panel p-3 mb-3">
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h4 class="mb-0">Modelos {{ brand ? ' de ' + brand.name : '' }}</h4>
        @if (perm.canCurrent('canCreate')) {
        <button class="btn btn-primary btn-sm" (click)="openForm()" [disabled]="!brand">
            <i class="fas fa-plus"></i>&nbsp;Nuevo Modelo
        </button>
        }
    </div>

    @if (!appSettings.isMobile()) {
    <div class="p-2">
        <div class="table-responsive table-data">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th class="text-nowrap" (click)="orderCol('code')"><a>Código<i class="fas ml-2"
                                    [ngClass]="{'fa-sort-alpha-down-alt':!order&&orderColName==='code','fa-sort-alpha-down':order&&orderColName==='code'}"></i></a>
                        </th>
                        <th class="text-nowrap" (click)="orderCol('name')">
                            <a>Nombre<i class="fas ml-2"
                                    [ngClass]="{'fa-solid fa-arrow-down-9-1':!order&&orderColName==='name','fa-solid fa-arrow-down-1-9':order&&orderColName==='name'}"></i></a>
                        </th>
                        <th class="text-nowrap" (click)="orderCol('year')"><a>Año</a></th>
                        <th class="text-nowrap" (click)="orderCol('vehicleType')"><a>Tipo</a></th>
                        <th class="text-nowrap text-center"><i class="fa-solid fa-gear"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @if(isLoading){
                    @for( i of rows ;track $index){
                    <tr class="tr-custom">
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                    </tr>
                    }
                    }

                    @if(filteredModels?.length>0 && !isLoading){
                    @for(model of filteredModels; track model.code) {
                    <tr style="cursor: pointer;" (click)="openForm(model)">
                        <td class="text-nowrap">{{ model.code }}</td>
                        <td class="text-nowrap">{{ model.name }}</td>
                        <td class="text-nowrap">{{ model.year }}</td>
                        <td class="text-nowrap">{{ model.vehicleType }}</td>
                        <td class="text-nowrap text-center">
                            <div class="btn-group btn-group-sm">
                                @if (perm.canCurrent('canUpdate')) {
                                <button type="button" class="btn btn-outline-primary btn-xs" title="Editar"
                                    (click)="openForm(model); $event.stopPropagation()">
                                    <i class="fas fa-pencil"></i>
                                </button>
                                }
                                @if (perm.canCurrent('canDelete')) {
                                <button type="button" class="btn btn-outline-danger btn-xs" title="Eliminar"
                                    (click)="deleteModel(model, $event)">
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                                }
                            </div>
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>

            @if(filteredModels?.length==0 && !isLoading){
            <div class="m-l-10 mb-2">
                <em>No hay datos</em>
            </div>
            }
        </div>
    </div>
    } @else {
    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <span class="small text-muted fw-bold text-uppercase">
            REGISTROS @if (!isLoading) { ({{ filteredModels.length }}) }
        </span>
    </div>
    <div class="model-cards-list">
        @if (isLoading) {
            @for (i of rows; track $index) {
                <app-list-card [isLoading]="true"></app-list-card>
            }
        } @else {
            @for (model of filteredModels; track model.code) {
                <app-list-card
                    [isShortcut]="true"
                    (click)="openForm(model)">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        {{ model.name }}
                    </div>
                    <div cardBadge>
                        <span class="badge text-bg-secondary">{{ model.code }}</span>
                    </div>
                    <div class="row g-1 text-muted small">
                        <div class="col-6">
                            <span class="text-muted">Año</span>
                            <div class="fw-semibold text-dark">{{ model.year || '—' }}</div>
                        </div>
                        <div class="col-6 text-end">
                            <span class="text-muted">Tipo</span>
                            <div class="fw-semibold text-dark">{{ model.vehicleType || '—' }}</div>
                        </div>
                    </div>
                </app-list-card>
            }
        }
        @if (!isLoading && filteredModels.length === 0) {
            <div class="card border-0 shadow-sm p-4 text-center my-2">
                <i class="fas fa-car-side fa-3x text-muted opacity-50 mb-2"></i>
                <h6 class="text-muted mb-1">Sin modelos</h6>
            </div>
        }
    </div>
    }
</div>
